import B2BAPI from './B2BAPI'

export const getCampaigns = async (params) => {
  try {
    const response = await B2BAPI.get('/campaign', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaign = async (b2bCampaignId) => {
  try {
    const response = await B2BAPI.get(`/campaign/${b2bCampaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const createCampaign = async (payload, attachments = []) => {
  try {
    const formData = new FormData()

    const jsonBlob = new Blob([JSON.stringify(payload)], {
      type: 'application/json'
    })
    formData.append('b2bCampaignDto', jsonBlob)

    if (attachments && attachments.length > 0) {
      attachments.forEach((file) => {
        formData.append('attachments', file)
      })
    }

    const response = await B2BAPI.post('/campaign', formData, {
      skipGenericErrorHandler: true
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getFirms = async (params) => {
  try {
    const response = await B2BAPI.get('/firms', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getRegistryFirms = async (apiController, payload) => {
  try {
    const response = await B2BAPI.post('/registry-firms/paginate', payload, {
      signal: apiController.signal
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getTemplates = async (params) => {
  try {
    const response = await B2BAPI.get('/email-template', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const selectFirms = async (payload) => {
  try {
    const response = await B2BAPI.post('/select-firms', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const abortSelectFirms = async (b2bCampaignId) => {
  try {
    const response = await B2BAPI.get('/select-firms/abort', {
      params: { b2bCampaignId }
    })
    return response.status === 204
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const sendEmailReply = async (payload) => {
  try {
    const response = await B2BAPI.post('/send-reply', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getMessages = async (params) => {
  try {
    const response = await B2BAPI.get('/campaign/messages', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const receive = async (params) => {
  try {
    const response = await B2BAPI.get('/receive', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateUser = async (userId, payload) => {
  try {
    const response = await B2BAPI.put(`/account/${userId}`, payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const createTemplate = async (payload) => {
  try {
    const response = await B2BAPI.post('/email-template', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateTemplate = async (templateId, payload) => {
  try {
    const response = await B2BAPI.put(`/email-template/${templateId}`, payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteTemplate = async (templateId) => {
  try {
    const response = await B2BAPI.delete(`/email-template/${templateId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteCampaign = async (campaignId) => {
  try {
    const response = await B2BAPI.delete(`/campaign/${campaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaignReport = async (b2bCampaignId) => {
  try {
    const response = await B2BAPI.get(`/report/campaign/${b2bCampaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getAccountReport = async (b2bAccountId) => {
  try {
    const response = await B2BAPI.get(`/report/account/${b2bAccountId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const generateAiEmailTemplate = async (payload) => {
  try {
    const response = await B2BAPI.post('/email-template/auto-generate', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaignFirms = async (params, page = 0, size = 10, filters = {}) => {
  try {
    const queryParams = {
      ...params,
      ...filters,
      page,
      size
    }
    const response = await B2BAPI.get('/campaign-firms', {
      params: queryParams
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaignFirmsAndState = async (params, page = 0, size = 10, filters = {}, sorting = {}) => {
  try {
    const queryParams = {
      ...params,
      ...filters,
      page,
      size,
      ...(sorting.sortBy && { sortBy: sorting.sortBy, direction: sorting.direction || 'ASC' })
    }
    const response = await B2BAPI.get('/campaign-firms-and-campaign-state', {
      params: queryParams
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateCampaignFirmSelection = async (payload) => {
  try {
    const response = await B2BAPI.post('/campaign-firms/selection', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateCampaignFirmEmailContent = async (payload) => {
  try {
    const response = await B2BAPI.post('/campaign-firms/email-content', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const approveCampaignFirmSelection = async (b2bCampaignId, positions = []) => {
  try {
    const response = await B2BAPI.post('/campaign/approve', { b2bCampaignId, positions })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateContactSelection = async (payload) => {
  try {
    const response = await B2BAPI.post('/contact/selection', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const approveContactSelection = async (b2bCampaignId) => {
  try {
    const response = await B2BAPI.post(`/contact/approve?b2bCampaignId=${b2bCampaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const startMailing = async (b2bCampaignId) => {
  try {
    const response = await B2BAPI.post(`/campaign/start-mailing?b2bCampaignId=${b2bCampaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const testSendSettings = async (emailSettings) => {
  try {
    const response = await B2BAPI.post('/settings/send/test', { ...emailSettings })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const testReceiveSettings = async (emailSettings) => {
  try {
    const response = await B2BAPI.post('/settings/receive/test', { ...emailSettings })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const downloadCampaignFirmsExcel = async (b2bCampaignId, selected = null, suitabilityLevelOrders = null) => {
  try {
    const params = { b2bCampaignId }
    if (selected !== null) {
      params.selected = selected
    }
    if (suitabilityLevelOrders && suitabilityLevelOrders.length > 0) {
      params.suitabilityLevelOrders = suitabilityLevelOrders
    }
    const response = await B2BAPI.get('/excel/campaign-firms', {
      params,
      paramsSerializer: {
        indexes: null
      },
      responseType: 'blob',
      headers: {
        Accept: '*/*'
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const unsubscribe = async (token) => {
  try {
    const response = await B2BAPI.get(`/unsubscribe?token=${token}`)
    return response.status === 200 ? response.data : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const scrapeEmailGeneratorParameters = async (website) => {
  try {
    const response = await B2BAPI.get('/account/scrape-email-generator-parameters', {
      params: { website }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaignStateContacts = async (b2bCampaignId, reportState) => {
  try {
    const response = await B2BAPI.get(`/report/campaign/${b2bCampaignId}/state/${reportState}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const exportCampaignStateContacts = async (b2bCampaignId, reportState) => {
  try {
    const response = await B2BAPI.get(`/report/campaign/${b2bCampaignId}/state/${reportState}/export`, {
      responseType: 'blob',
      headers: {
        Accept: '*/*'
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}
